var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.6,
    height: 22.6,
    viewBox: "0 0 22.6 22.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5360",
    "data-name": "Gruppe 5360",
    transform: "translate(-749.595 -520.452)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_777",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#ea5460",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: "1.6px",
    "data-name": "Ellipse 777",
    transform: "translate(750.395 521.252)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    fill: "#fff",
    "data-name": "!",
    fontFamily: "Domus-Extrabold, Domus",
    fontSize: "14px",
    fontWeight: 800,
    transform: "translate(758.896 535.97)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.373ee59e.svg";
export { ForwardRef as ReactComponent };